var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundHomepageMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 960 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#458b8b;}.cls-2{fill:#539190;}.cls-3{fill:#5b9797;}.cls-4{fill:#679fa0;}.cls-5{fill:#73a6a7;}.cls-6{fill:url(#Unbenannter_Verlauf_2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: 880,
    y1: 873.67,
    x2: 880,
    y2: 1002,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#438989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeced"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 924.04,
    cy: 130.05,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 924.04,
    cy: 120.87,
    r: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 924.04,
    cy: 111.12,
    r: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 924.04,
    cy: 102.04,
    r: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 924.04,
    cy: 92.93,
    r: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 932.51,
    cy: 130.05,
    r: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 932.51,
    cy: 120.87,
    r: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 932.51,
    cy: 111.12,
    r: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 932.51,
    cy: 102.04,
    r: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 932.51,
    cy: 92.93,
    r: 0.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.61,
    cy: 130.05,
    r: 0.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 940.61,
    cy: 120.87,
    r: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 940.61,
    cy: 111.12,
    r: 0.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 940.61,
    cy: 102.04,
    r: 0.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 940.61,
    cy: 92.93,
    r: 0.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 949.32,
    cy: 130.05,
    r: 0.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 949.32,
    cy: 120.87,
    r: 0.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 949.32,
    cy: 111.12,
    r: 0.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 949.32,
    cy: 102.04,
    r: 0.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 958.49,
    cy: 130.05,
    r: 0.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 958.49,
    cy: 120.87,
    r: 0.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 958.49,
    cy: 111.12,
    r: 0.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 958.49,
    cy: 102.04,
    r: 0.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 915.4,
    cy: 130.11,
    r: 0.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 915.4,
    cy: 120.94,
    r: 0.5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 915.4,
    cy: 111.18,
    r: 0.5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 915.4,
    cy: 102.1,
    r: 0.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 915.4,
    cy: 92.99,
    r: 0.5
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 949.31,
    cy: 92.91,
    r: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M802.08,0H960V126.81a18.24,18.24,0,0,1-11.87.92c-6.34-1.68-13.68-11-15.92-13.8-3.76-4.61-6-8-7-9.39-2.72-3.82-7.64-8.82-17.3-13.62a48.32,48.32,0,0,0-11.5-3.5c-6.26-1.07-10.25-.46-17.85-.36a161,161,0,0,1-17.21-.74,22.22,22.22,0,0,1-13.71-7,42,42,0,0,1-4.42-6.26c-4.45-7.73-3.51-11.86-7.64-19.33a43.93,43.93,0,0,0-6.81-9c-4.62-5-6.58-5.16-13-10.58-6-5.09-10-8.43-12.89-14.35a23,23,0,0,1-2.76-13.35A20.61,20.61,0,0,1,802.08,0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundHomepageMobile);
export default __webpack_public_path__ + "static/media/background_homepage_mobile.d3145def1d6df5010fcb18974c455552.svg";
export { ForwardRef as ReactComponent };